module.exports = __webpack_public_path__ + "img/parceMask.32f8a5ac.png";